const UserActionTypes = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  RESETPASSWORD: 'RESETPASSWORD',
  FORGET_PASSWORD: 'FORGET_PASSWORD',
};

export default UserActionTypes;
